
import {
    Create, TextInput, BooleanInput, NumberInput, SelectInput,
    Edit, FormDataConsumer, Toolbar,
    Form,
    TransformData,
    required
} from "react-admin";


import { Card, CardContent, Divider, Grid, Paper, Stack } from "@mui/material";
import { ImageInputSafe } from "@/src/components";
import { emptify } from "@/src/utils";
import { TargetEditSection, PricingInput, StoreRefsInput } from "./Sections";


const SubscriptionProductContent = () =>
    <Card>
        <CardContent>
            <Stack>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <TextInput source="title" validate={required()} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <TextInput source="description" />
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>

                        <Stack direction={"row"} spacing={2}>
                            <NumberInput source="duration" validate={required()} />
                            <SelectInput source="units" label="units" validate={required()} choices={[
                                { id: 'hour', name: 'Hour' },
                                { id: 'day', name: 'Days' },
                                { id: 'week', name: 'Week' },
                                { id: 'month', name: 'Month' }
                            ]} />
                        </Stack>

                        <Stack direction={"row"} spacing={2}>
                            <BooleanInput source="autoRenewal" helperText={false} sx={{ flexShrink: 0 }} />
                            <FormDataConsumer>
                                {({ formData }) =>
                                    formData.autoRenewal && <NumberInput source="renewalCycles" step={1} />
                                }
                            </FormDataConsumer>
                        </Stack>

                        <Stack direction={"row"} spacing={2}>
                            <BooleanInput source="recommended" />
                            <BooleanInput source="active" />
                        </Stack>

                        <NumberInput source="displayOrder" />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <ImageInputSafe source="imageUrl"
                            accept={{ 'image/*': ['.jpeg', '.jpg', '.png', '.svg'], }}
                            multiple={false} />
                    </Grid>
                </Grid>
                <Card>
                    <CardContent>
                        <BooleanInput source="storeProduct" helperText={false} sx={{ flexShrink: 0 }} />
                        <FormDataConsumer>{({ formData }) =>
                            <>
                                {!formData.storeProduct && <TargetEditSection />}
                                {formData.storeProduct && <StoreRefsInput source="storeRefs" />}
                                {!formData.storeProduct && <PricingInput source="pricing" />}
                            </>}
                        </FormDataConsumer>

                    </CardContent>
                </Card>


            </Stack>
        </CardContent>
        <Toolbar />
    </Card>

const transform: TransformData = (data: any) => {
    data.pricing?.forEach((prc: any) => {
        emptify(prc);
    });
    if (data.storeRefs) {
        data.storeRefs = data.storeRefs.filter(
            (ref: { store?: string; sku?: string }) => ref?.store && ref?.sku
        );
    }
    // emptify(data, "target")

    return data;
}

export const SubscriptionProductCreate = () => {

    return (
        <Create transform={transform}>
            <Form sanitizeEmptyValues>
                <SubscriptionProductContent />
            </Form>
        </Create>
    );

}


export const SubscriptionProductEdit = () => {

    return (
        <Edit transform={transform}>
            <Form sanitizeEmptyValues>
                <SubscriptionProductContent />
            </Form>
        </Edit>
    );

}

